import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import BenefitsSection from './components/BenefitsSection';
import ArticleGrid from './components/ArticleGrid';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import ArticleCTA from './components/ArticleCTA';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = 'https://vigorbuyspread.site';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'VigorBuy Spreadsheet',
      url: SITE_URL,
      description: 'The ultimate resource for VigorBuy Spreadsheet and Kakobuy Spreadsheet shopping guides, product databases, QC photos and buying tips.',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'VigorBuy Spreadsheet',
      url: SITE_URL,
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg',
      description: 'The ultimate resource for VigorBuy Spreadsheet and Kakobuy Spreadsheet shopping guides, product databases, QC photos and buying tips.',
      sameAs: ['https://kaspreadsheet.com'],
    },
  ],
};

export default function Home() {
  return (
    <main>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <WhatIsSection />
      <BenefitsSection />
      <ArticleGrid />
      <SafetySection />
      <FAQSection />
      <ArticleCTA />
      <Footer />
    </main>
  );
}